<template>
   <div id="layoutDefault">
            <div id="layoutDefault_content">
                <main>
                    <MainNav />
                    <header class="page-header page-header-dark bg-gradient-primary-to-secondary">
                        <div class="page-header-content">
                        </div>
                        <div class="svg-border-rounded text-light">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </header>
                    <section class="bg-light py-10">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-lg-10 col-xl-8">
                                    <div class="single-post">
                                        <h1>Accommodations Toolkit</h1>
                                        <p class="lead">An accommodation is a modification or change that would allow an individual to do something
                                            they may not otherwise be able to do. Accommodations help remove barriers to provide equal
                                            access (i.e. help level the playing field). They don’t lower the expectations that are asked of you,
                                            but instead will help you work around specific challenges you face.</p>
                                        <div class="d-flex align-items-center justify-content-between mb-5">
                                            <div class="single-post-meta mr-4">
                                                <div class="single-post-meta-details">
                                                    <div class="single-post-meta-details-name"><i class="fas fa-tag"></i> Accommodations</div>
                                                    <div class="single-post-meta-details-date">Feb 5 &#xB7; 18 min read</div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <img class="img-fluid mb-2" src="https://d3n8a8pro7vhmx.cloudfront.net/improvecarenow/pages/264/attachments/original/1456001033/cover_of_book.jpg?1456001033" /> -->
                                        <div class="single-post-text my-5">
                                            <p>Accommodations exist to make things better accessible - you should never feel guilty using
                                                accommodations, especially if it means you will be more able to manage your illness and take
                                                care of yourself. When you're sick, the last thing you need is extra stress, and you shouldn’t
                                                have to sacrifice your health or well-being for anything. Accommodations can help ensure you
                                                are adequately supported, so you can better manage your illness and life!
                                            </p>
                                            <a href="http://bit.ly/2EbHzVK" target="_blank"><i class="fas fa-file-pdf"></i> Download Handbook</a>
                                            <div class="text-center"><router-link class="btn btn-transparent-dark btn-marketing rounded-pill" to="/resource-list">Back to Resources</router-link></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="svg-border-rounded text-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </section>
                </main>
            </div>
            <div id="layoutDefault_footer">
                <MainFooter />
            </div>
        </div>
</template>

<script>
import $ from 'jquery';
import MainNav from '@/components/nav.vue'
import MainFooter from '@/components/footer.vue'

export default {
  name: 'Home',
  components: {
    MainNav,
    MainFooter
  }
}
// Collapse Navbar
// Add styling fallback for when a transparent background .navbar-marketing is scrolled
var navbarCollapse = function() {
    if($(".navbar-marketing.bg-transparent.fixed-top").length === 0) {
        return;
    }
    if ($(".navbar-marketing.bg-transparent.fixed-top").offset().top > 0) {
        $(".navbar-marketing").addClass("navbar-scrolled");
    } else {
        $(".navbar-marketing").removeClass("navbar-scrolled");
    }
};
// Collapse now if page is not at top
navbarCollapse();
// Collapse the navbar when page is scrolled
$(window).scroll(navbarCollapse);



</script>
